import { render, staticRenderFns } from "./redeem-code-records.vue?vue&type=template&id=71b60977&scoped=true&"
import script from "./redeem-code-records.vue?vue&type=script&lang=js&"
export * from "./redeem-code-records.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b60977",
  null
  
)

export default component.exports